
// @ts-nocheck
import locale__app_locales_en_US_yml from "../locales/en-US.yml";
import locale__app_locales_zh_CN_yml from "../locales/zh-CN.yml";
import locale__app_locales_pt_PT_yml from "../locales/pt-PT.yml";


export const localeCodes =  [
  "en",
  "zh",
  "pt"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en-US.yml", load: () => Promise.resolve(locale__app_locales_en_US_yml), cache: true }],
  "zh": [{ key: "../locales/zh-CN.yml", load: () => Promise.resolve(locale__app_locales_zh_CN_yml), cache: true }],
  "pt": [{ key: "../locales/pt-PT.yml", load: () => Promise.resolve(locale__app_locales_pt_PT_yml), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "iso": "en-US",
      "files": [
        "locales/en-US.yml"
      ]
    },
    {
      "code": "zh",
      "iso": "zh-CN",
      "files": [
        "locales/zh-CN.yml"
      ]
    },
    {
      "code": "pt",
      "iso": "pt-PT",
      "files": [
        "locales/pt-PT.yml"
      ]
    }
  ],
  "defaultLocale": "zh",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "iso": "en-US",
    "files": [
      {
        "path": "locales/en-US.yml"
      }
    ]
  },
  {
    "code": "zh",
    "iso": "zh-CN",
    "files": [
      {
        "path": "locales/zh-CN.yml"
      }
    ]
  },
  {
    "code": "pt",
    "iso": "pt-PT",
    "files": [
      {
        "path": "locales/pt-PT.yml"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
